__turbopack_context__.v({
  "contactForm": "contact-us-module-scss-module__rnaW5q__contactForm",
  "contactFormContainer": "contact-us-module-scss-module__rnaW5q__contactFormContainer",
  "contactFormInfo": "contact-us-module-scss-module__rnaW5q__contactFormInfo",
  "contactPageSection": "contact-us-module-scss-module__rnaW5q__contactPageSection",
  "contactPageSection__Left": "contact-us-module-scss-module__rnaW5q__contactPageSection__Left",
  "contactPageSection__Right": "contact-us-module-scss-module__rnaW5q__contactPageSection__Right",
});
